import React, { ReactNode } from 'react'
import { Box, Text, Button } from '@mantine/core'

interface Props {
  icon?: ReactNode;
  title: string;
  message?: string;
  action?: { label: string; onClick: () => void };
}

export default function EmptyState ({ icon, title, message, action }: Props) {
  return (
    <Box
      sx={{
        textAlign: 'center',
        padding: '48px 24px'
      }}
    >
      {icon && (
        <Box sx={{ marginBottom: 16, display: 'flex', justifyContent: 'center' }}>
          {icon}
        </Box>
      )}
      <Text weight={600} size="lg" color="dark">
        {title}
      </Text>
      {message && (
        <Text size="sm" color="dimmed" mt="xs">
          {message}
        </Text>
      )}
      {action && (
        <Button
          variant="light"
          size="sm"
          mt="md"
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </Box>
  )
}
